(ns frontend.view.settings2.authorized-applications.events
  (:require
   [frontend.utils :as fu]
   [frontend.actions.tenant :as tenant-actions]
   [frontend.logging :as logging]))

(defn load-api-tokens
  [state]
  (tenant-actions/*->api-tokens {}
                                (fn [resp]
                                  (swap! state assoc
                                    :state :loaded
                                    :api-tokens (some->> resp
                                                         :body)))
                                (fn [err]
                                  (swap! state assoc
                                    :state :loaded
                                    :error err))))

(defn save!
  [updates-state state token]
  (tenant-actions/*->update-api-token!
   {:db/id (:db/id token)
    :token/device-nick-name (:token/device-nick-name @updates-state)
    :token/ip-filters (pr-str (:token/ip-filters @updates-state))}
   (fn [resp]
     (swap! state assoc
       :api-tokens
       (some->> resp
                :body)))
   (fn [err]
     (logging/error "Failed to update api-token " (:message err)))))

(defn rotate!
  [state token]
  (tenant-actions/*->rotate-api-token!
   {:db/id (:db/id token)}
   (fn [resp]
     (swap! state assoc
       :api-tokens
       (some->> resp
                :body)))
   (fn [err]
     (logging/error "Failed to rotate api-token " (:message err)))))

(defn revoke!
  [state token]
  (tenant-actions/*->revoke-api-token!
   {:db/id (:db/id token)}
   (fn [resp]
     (swap! state assoc
       :api-tokens
       (some->> resp
                :body)))
   (fn [err]
     (logging/error "Failed to revoke api-token " (:message err)))))
